import React, { useContext, useEffect, useState } from 'react';
import { GeoAlt } from 'react-bootstrap-icons';

import { MapContext } from '../../context/map';
import useTranslation from '../../hooks/use_translation';
import Btn from '../framework/buttons/btn';
import Loader from '../framework/loader';

const LocationMapGeoLocation = () => {
	const {
		geoLocationState,
		getGeoLocation,
		hasGeoLocation,
		map,
		resetGeoLocation,
	} = useContext(MapContext);
	const [marker, setMarker] = useState();
	const { t } = useTranslation('component_location_map_get_location');

	const toggleGeoLocation = () => {
		if (!geoLocationState?.position) getGeoLocation();
		else {
			resetGeoLocation();
			marker.setMap(null);
			setMarker(null);
		}
	};

	useEffect(() => {
		if (geoLocationState?.position && map && !marker) {
			const new_marker = new window.google.maps.Marker({
				icon: {
					fillColor: 'blue',
					fillOpacity: 1.0,
					path: window.google.maps.SymbolPath.CIRCLE,
					scale: 6,
					strokeColor: 'white',
					strokeOpacity: 1.0,
					strokeWeight: 2,
				},
				map: map,
				position: {
					lat: geoLocationState.position.latitude,
					lng: geoLocationState.position.longitude,
				},
				title: t('t2'),
			});

			map.panTo(new_marker.getPosition());
			map.setZoom(12);

			setMarker(new_marker);
		}
	}, [geoLocationState, map, marker, t]);

	if (!hasGeoLocation()) return;

	return (
		<Btn
			className="d-flex justify-content-center text-primary gap-2"
			color="light"
			component="button"
			onClick={toggleGeoLocation}
			size="sm"
			variant="link"
		>
			{geoLocationState.status == 'loading' ? <Loader /> : <GeoAlt />}
			{t('t1')}
		</Btn>
	);
};

export default LocationMapGeoLocation;
